module.exports = __webpack_public_path__ + "img/lazy-loading.05952523.png";